const base = {
  cardTitle: 'Share Daily Quiz to WhatsApp',
  cardSubtitle: 'Generate a branded question card and send it straight into your group chat. Perfect for daily engagement.',
  cardMeta: 'Takes about 60 seconds • Manual tally tools included',
  instructionSingle: 'Reply with the letter of your answer.',
  instructionMultiple: 'Reply with every correct letter (e.g. AC).',
  instructionTrueFalse: 'Reply with the matching letter for True or False.',
  instructionFillBlank: 'Reply with the word or phrase that completes the blank.',
  instructionOrdering: 'Reply with the correct order (e.g. CADB).',
  fillChoicesLabel: 'Answer choices',
  screenTitle: 'WhatsApp Daily Quiz Share',
  screenSubtitle: 'Preview the branded card, add your intro line, and share straight into your group chat. A text fallback is provided for low-bandwidth users.',
  previewBadge: 'Daily Challenge',
  previewFooter: 'Powered by Kingdom Bible Quiz • Available on Android & iOS',
  previewComposerNote: 'Preview only — the actual share uses WhatsApp\'s native composer.',
  introLabel: 'Intro line (optional)',
  introPlaceholder: "Hey family! Let's tackle today's question together.",
  groupLabel: 'Group label (optional)',
  groupPlaceholder: 'Family Group',
  shareTitle: 'Kingdom Bible Quiz - Daily Challenge',
  shareButton: 'Share to WhatsApp',
  shareButtonLoading: 'Sharing…',
  shareGuidelines: 'Respect group guidelines. We store the share locally so you don\'t repeat the same question too soon.',
  loadAnotherPrompt: 'Need a different question?',
  loadAnotherAction: 'Load another',
  fallbackLabel: 'Low-bandwidth fallback message',
  fallbackHelper: 'Copy & paste if media sharing fails.',
  manualHeading: 'Manual Response Tally',
  manualHelper: 'Tap plus or minus to track responses as they come in. Use this panel while monitoring the group chat.',
  manualHelperMultiple: 'Track how many participants listed each option so you can credit everyone with multiple correct answers.',
  manualHelperOrdering: 'Tally the first correct sequence you see from the group to spotlight quick solvers.',
  manualHelperFillBlank: 'Count each correct keyword and capture creative answers to celebrate later.',
  manualHelperTrueFalse: 'Log True/False votes quickly so you can share the final split with the group.',
  correctAnswerTag: 'Correct answer',
  topResponderLabel: 'Top responder (optional)',
  topResponderPlaceholder: 'Add a name to celebrate in your follow-up post',
  clearTallies: 'Clear tallies',
  recentSharesLabel: 'Recent shares',
  recentSharesEmpty: 'No WhatsApp shares logged yet.',
  etiquetteTitle: 'Etiquette tip',
  etiquetteText: 'Post the answer within the hour, tag the quickest responders, and drop the solo-mode deep link to keep momentum.',
  loadingText: 'Loading daily quiz…',
  shareSuccessTitle: 'Shared!',
  shareSuccessBody: 'Your daily question was sent. Track replies below and send the answer recap when ready.',
  shareErrorTitle: 'Unable to share',
  shareErrorBody: 'Check that WhatsApp is installed and try again.',
};

export const whatsappEngagement = {
  en: base,
  es: base,
  fr: base,
  de: base,
  pt: base,
  ru: base,
  tl: base,
  it: base,
  am: base,
  ko: base,
};


